module.exports = __webpack_public_path__ + "img/exclusive.d5d5aa5a.svg";